import {create} from 'zustand';

interface ContractDocumentUpdateModalState {
  updatableId: string | null;
  fileName: string;
  description: string;

  documentUpdateModalOpen: (
    props: Omit<ContractDocumentUpdateModalState, 'documentUpdateModalClose' | 'documentUpdateModalOpen'>,
  ) => void;
  documentUpdateModalClose: () => void;
}

export const useContractDocumentUpdateModalStore = create<ContractDocumentUpdateModalState>((set) => ({
  updatableId: null,
  fileName: '',
  description: '',

  documentUpdateModalOpen: (props) => set({...props}),
  documentUpdateModalClose: () => set({updatableId: null, fileName: '', description: ''}),
}));

export const {documentUpdateModalClose, documentUpdateModalOpen} = useContractDocumentUpdateModalStore.getState();
